import React, { useEffect, useState } from 'react';
import CountdownDisplay from './CountdownDisplay';

interface StickyMobileCtaProps {
  heroRef: React.RefObject<HTMLElement | null>;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const StickyMobileCta: React.FC<StickyMobileCtaProps> = ({ heroRef, days, hours, minutes, seconds }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const heroHeight = heroRef.current?.offsetHeight ?? 600;
      setVisible(window.scrollY > heroHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [heroRef]);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0a1030]/95 backdrop-blur-md transition-transform duration-300 md:hidden ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <div className="leading-tight">
          <div className="text-xs text-white/60">Comienza en</div>
          <CountdownDisplay days={days} hours={hours} minutes={minutes} seconds={seconds} compact />
        </div>
        <a href="#registro" className="btn-mc-glow whitespace-nowrap px-5 py-2.5 text-sm">
          Registrarme gratis
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCta;
